import { gql } from 'graphql-request'

export const GET_WRITING_LIST = gql`
  query GetWritingList(
    $penNameId: [Int!]
    $name: String
    $category: [Int!]
    $bookType: [BookType!]
    $page: Int
    $limitPerPage: Int
    $orderBy: writingOrderBy
  ) {
    getWritingList(
      penNameId: $penNameId
      name: $name
      category: $category
      bookType: $bookType
      page: $page
      limitPerPage: $limitPerPage
      orderBy: $orderBy
    ) {
      total
      page
      data {
        id
        coverImgPath
        coverResizeImgPath
        title
        bookType
        status
        likeCount
        commentCount
        viewCount
        amountSpent
        penName {
          id
          firstPenName
        }
        writingType
        bookType
        isBanned
        isVisible
        totalEbookSeries
      }
    }
  }
`
